"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUndefined = void 0;
var isUndefined = function isUndefined(data) {
  return typeof data === 'undefined';
};
exports.isUndefined = isUndefined;